import type { FrontendWidget } from '../types';
import { CompactRatingComponent } from './CompactRatingComponent';
import { CompactRatingComponentC } from './CompactRatingComponentC';
import type { CompactRatingConfig, CompactRatingResolved } from './types';

export const compactRatingWidget: FrontendWidget<
  CompactRatingConfig,
  CompactRatingResolved
> = {
  componentType: 'widgets.compact-rating',
  displayName: 'Compact Rating',
  ComponentA: CompactRatingComponent,
  ComponentC: CompactRatingComponentC,
  resolveSync: (config) => config,
};
